function parse<T>(env: any, parse: (a: any) => T, def?: T): T {
  // @ts-expect-error
  return env ? parse(env) : def;
}

export const API_BASE_URL = parse(import.meta.env.VITE_API_BASE_URL, String, 'http://localhost:23193/api');
export const IS_PROD = parse(import.meta.env.PROD, Boolean, false);
export const GMAPS_API_KEY = parse(
  import.meta.env.VITE_GMAPS_API_KEY,
  String,
  'AIzaSyAgC04cD-igXteLnuUcdEzDko2C_xLpKoc'
);

export const FARM_DAY = 'farm-day';

export const VITE_SENTRY_DSN = parse(import.meta.env.VITE_SENTRY_DSN, String);
export const VITE_FDM_ENV = parse(import.meta.env.VITE_FDM_ENV, String, 'local');
export const VITE_FDM_VERSION = parse(import.meta.env.VITE_FDM_VERSION, String, 'latest');

export const FARM_DAY_KEY = 'feed-farm-day';
export const AUTH_KEY = 'feed-auth';

export const FEED_SESSION = 'FEED:current-session';

export enum Sessions {
  admin = 'Painel',
  reports = 'Relatórios',
  management = 'Manejo',
  tract = 'Trato',
  diet = 'Dieta',
  financial = 'Financeiro',
  traceability = 'Rastreabilidade',
  farm = 'Fazenda',
  medicalServices = 'Sanidade',
  logout = 'Sair',
  batches = 'Lotes avulsos'
}

export const RESPONSIVE_LAYOUT_STORAGE = 'FEED:responsive-layout';

export const commonResponsiveLayout = {
  md: [
    { i: 'A1', x: 0, y: 0, w: 2, h: 20, minW: 2, minH: 10 },
    { i: 'A2', x: 2, y: 0, w: 2, h: 20, minW: 2, minH: 10 },
    { i: 'A3', x: 4, y: 0, w: 2, h: 20, minW: 2, minH: 10 },
    { i: 'A4', x: 6, y: 0, w: 2, h: 20, minW: 2, minH: 20 },
    { i: 'A5', x: 0, y: 1, w: 8, h: 20, minH: 20 },
    { i: 'A6', x: 0, y: 2, w: 8, h: 20, minH: 20 }
  ],
  xxs: [
    { i: 'A1', x: 0, y: 0, w: 0.5, h: 10 },
    { i: 'A2', x: 1, y: 0, w: 0.5, h: 10 },
    { i: 'A3', x: 0, y: 0, w: 0.5, h: 10 },
    { i: 'A4', x: 1, y: 0, w: 0.5, h: 10 },
    { i: 'A5', x: 0, y: 1, w: 4, h: 4 },
    { i: 'A6', x: 0, y: 2, w: 4, h: 4 }
  ]
};
